import type { Membership, User } from './types';

// Ports the legacy Redux `user` duck state — its `currentUser` plus
// `currentUserMembership` — into the v2 zustand store `User`.
export function fromReduxUserDuckToUser(
  reduxCurrentUser: unknown,
  rawMembership?: unknown
): User | null {
  if (!reduxCurrentUser || typeof reduxCurrentUser !== 'object') return null;

  const user = reduxCurrentUser as {
    id?: { uuid?: string };
    attributes?: {
      profile?: {
        firstName?: string;
        lastName?: string;
        displayName?: string;
      };
      email?: string;
      emailVerified?: boolean;
    };
  };

  const id = user.id?.uuid;
  if (!id) return null;

  const profile = user.attributes?.profile ?? {};

  return {
    id,
    firstName: profile.firstName ?? '',
    lastName: profile.lastName ?? '',
    displayName: profile.displayName ?? '',
    email: user.attributes?.email ?? '',
    isEmailVerified: user.attributes?.emailVerified ?? false,
    membership: (rawMembership ?? null) as Membership | null,
  };
}
